<div class="header">
  <div class="history">
    {{ drafts.length ? drafts.length : "no" }}
    {{ drafts.length > 1 ? "drafts" : "draft" }} saved
  </div>
  <span class="spacer"></span>
  <div class="buttons">
    <button
      mat-stroked-button
      class="mr-1"
      [disabled]="!drafts.length"
      (click)="removeAllDrafts()"
    >
      Remove all drafts
    </button>
  </div>
</div>
@if (drafts.length) {
  <mat-list>
    @for (draft of drafts; track draft) {
      <mat-list-item>
        <div class="draft">
          <div class="item-title">{{ draft.title }}</div>
          <div class="item-date">{{ draft.date }}</div>
          <button mat-stroked-button (click)="loadDraft(draft)">
            Load draft
          </button>
        </div>
      </mat-list-item>
    }
  </mat-list>
}
